<div class="container">
    <h1
        [innerHTML]="'conditions-utilisation-pes.titre' | translate"></h1>

    <div class="navigation">
        <h2 [innerHTML]="'conditions-utilisation-pes.toc' | translate"></h2>
        <nav>
            <ul>
                <li>
                    <a href="/conditions-utilisation#section-portail-gestion-territoire-public"
                        [innerHTML]="'conditions-utilisation-pes.portail-gestion-territoire-public.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-acceptation-conditions-utilisation"
                        [innerHTML]="'conditions-utilisation-pes.acceptation-conditions-utilisation.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-protection-renseignements-personnels-securite"
                        [innerHTML]="'conditions-utilisation-pes.protection-renseignements-personnels-securite.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-propriete-intellectuelle"
                        [innerHTML]="'conditions-utilisation-pes.propriete-intellectuelle.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-utilisation-portail"
                        [innerHTML]="'conditions-utilisation-pes.utilisation-portail.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-exactitude-information"
                        [innerHTML]="'conditions-utilisation-pes.exactitude-information.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-disponibilite-service"
                        [innerHTML]="'conditions-utilisation-pes.disponibilite-service.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-exclusion-responsabilite"
                        [innerHTML]="'conditions-utilisation-pes.exclusion-responsabilite.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-contact"
                        [innerHTML]="'conditions-utilisation-pes.contact.titre' | translate"></a>
                </li>
            </ul>
        </nav>
    </div>

    <div class="sections">
        <div id="section-portail-gestion-territoire-public">
            <h2 [innerHTML]="'conditions-utilisation-pes.portail-gestion-territoire-public.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation-pes.portail-gestion-territoire-public.texte' | translate">
            </div>
        </div>

        <div id="section-acceptation-conditions-utilisation">
            <h2 [innerHTML]="'conditions-utilisation-pes.acceptation-conditions-utilisation.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation-pes.acceptation-conditions-utilisation.texte' | translate">
            </div>
        </div>

        <div id="section-protection-renseignements-personnels-securite">
            <h2
                [innerHTML]="'conditions-utilisation-pes.protection-renseignements-personnels-securite.titre' | translate">
            </h2>
            <div
                [innerHTML]="'conditions-utilisation-pes.protection-renseignements-personnels-securite.texte' | translate">
            </div>
        </div>

        <div id="section-propriete-intellectuelle">
            <h2 [innerHTML]="'conditions-utilisation-pes.propriete-intellectuelle.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation-pes.propriete-intellectuelle.texte' | translate">
            </div>
        </div>

        <div id="section-utilisation-portail">
            <h2 [innerHTML]="'conditions-utilisation-pes.utilisation-portail.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation-pes.utilisation-portail.texte' | translate">
            </div>
        </div>

        <div id="section-exactitude-information">
            <h2 [innerHTML]="'conditions-utilisation-pes.exactitude-information.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation-pes.exactitude-information.texte' | translate">
            </div>
        </div>

        <div id="section-disponibilite-service">
            <h2 [innerHTML]="'conditions-utilisation-pes.disponibilite-service.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation-pes.disponibilite-service.texte' | translate">
            </div>
        </div>

        <div id="section-exclusion-responsabilite">
            <h2 [innerHTML]="'conditions-utilisation-pes.exclusion-responsabilite.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation-pes.exclusion-responsabilite.texte' | translate">
            </div>
        </div>

        <div id="section-contact">
            <h2 [innerHTML]="'conditions-utilisation-pes.contact.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation-pes.contact.texte' | translate">
            </div>
        </div>

    </div>

</div>